function SvgTransactions({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.66663 18.1633H21.3333V6.66666H2.66663V18.1633Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3592 11.7035C14.9851 11.7035 15.5854 11.9472 16.028 12.3809C16.4706 12.8147 16.7192 13.403 16.7192 14.0165C16.7192 14.6299 16.4706 15.2182 16.028 15.652C15.5854 16.0858 14.9851 16.3295 14.3592 16.3295C13.7333 16.3295 13.133 16.0858 12.6904 15.652C12.2478 15.2182 11.9992 14.6299 11.9992 14.0165C11.9992 13.403 12.2478 12.8147 12.6904 12.3809C13.133 11.9472 13.7333 11.7035 14.3592 11.7035Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7141 11.7035C17.34 11.7035 17.9403 11.9472 18.3829 12.3809C18.8255 12.8147 19.0741 13.403 19.0741 14.0165C19.0741 14.6299 18.8255 15.2182 18.3829 15.652C17.9403 16.0858 17.34 16.3295 16.7141 16.3295C16.0882 16.3295 15.4879 16.0858 15.0454 15.652C14.6028 15.2182 14.3541 14.6299 14.3541 14.0165C14.3541 13.403 14.6028 12.8147 15.0454 12.3809C15.4879 11.9472 16.0882 11.7035 16.7141 11.7035Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgTransactions;
